import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=5ed75876&"
import script from "./Terms.vue?vue&type=script&lang=ts&"
export * from "./Terms.vue?vue&type=script&lang=ts&"
import style0 from "./Terms.vue?vue&type=style&index=0&id=5ed75876&prod&lang=scss&"
import style1 from "./Terms.vue?vue&type=style&index=1&id=5ed75876&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports